import _Quill from 'quill'
const Quill = window.Quill || _Quill

const icons = Quill.import('ui/icons');

icons['bold']         = '<i class="fa fa-bold" aria-hidden="true"></i>';
icons['italic']       = '<i class="fa fa-italic" aria-hidden="true"></i>';
icons['underline']    = '<i class="fa fa-underline" aria-hidden="true"></i>';
icons['strike']       = '<i class="fa fa-strikethrough" aria-hidden="true"></i>';
icons['color']        = '<i class="fa fa-palette" aria-hidden="true"></i>';
icons['background']   = '<i class="fa fa-square-full" aria-hidden="true"></i>';
icons['list']         = {
  'bullet'  : '<i class="fa fa-list" aria-hidden="true"></i>',
  'check'   : '<i class="fa fa-tasks" aria-hidden="true"></i>',
  'ordered' : '<i class="fa fa-list-ol" aria-hidden="true"></i>',
};

icons['align']        = {
  ''      : '<i class="fa fa-align-left" aria-hidden="true"></i>',
  center  : '<i class="fa fa-align-center" aria-hidden="true"></i>',
  right   : '<i class="fa fa-align-right" aria-hidden="true"></i>',
  justify : '<i class="fa fa-align-justify" aria-hidden="true"></i>',
};

icons['link']         = '<i class="fa fa-link" aria-hidden="true"></i>';

icons['image']        = '<i class="far fa-image" aria-hidden="true"></i>';

icons['header']       = '<i class="fa fa-heading" aria-hidden="true"></i>';

Quill.register('modules/counter', () => {});

import { dom } from '@fortawesome/fontawesome-svg-core'

export default {
  data(){
    return {
      quill             : null,
      quillTooltip      : null,
      isQuillMounted    : false,

      defaultLinkURL    : 'https://akibatrical.tokyo/',
      inputURLText      : 'URLを入力',
      quillPlaceholder  : '内容を入力',
      quillHtmlID       : '#editor-container',
      inputCount        : 0
    };
  },

  methods : {
    initializeQuillObject(){
      return new Quill(this.$refs.quillEditor, {
        theme     : 'snow',
        modules   : {
          toolbar : {
            container   : this.$refs.quillToolbar,
            handlers    : {
              link : function(value) {
                if (value) {
                  this.quill.format('link', prompt(this.inputURLText));
                } else {
                  this.quill.format('link', false);
                }
              }
            },
          },
          counter: true
        },
        placeholder : this.quillPlaceholder,
        bounds      : this.quillHtmlID
      });
    },

    initializeQuillModules(){
      var toolbar = this.quill.getModule('toolbar');

      toolbar.addHandler('image', () => {
        if(typeof this.$refs.imageFileInput !== 'undefined'){
          this.$refs.imageFileInput.click();
        }
      });
    },

    getHtmlData(){
      const htmlData = document.createElement('div');

      (new Quill(htmlData)).setContents( this.quill.getContents() );

      return htmlData.getElementsByClassName('ql-editor')[0].innerHTML;
    },

    getTextData(htmlData){
      const testDom = document.createElement('div');
      testDom.innerHTML = htmlData;

      return testDom.textContent || testDom.innerText || '';
    },

    getTextCount(){
      const htmlData    = this.getHtmlData();
      const textData    = this.getTextData(htmlData);
      return textData.replace(/\s/g, '').length;
    }
  },

  mounted(){
    // dom.watchはfontawsomeのiconです。
    dom.watch();

    this.quill = this.initializeQuillObject();

    this.initializeQuillModules();

    this.quillTooltip = this.quill.theme.tooltip;
    const linkInputField = this.quillTooltip.root.querySelector("input[data-link]");
    linkInputField.dataset.link = this.defaultLinkURL;

    this.quill.on('text-change', () => {
      const text    = this.quill.getText();
      const counter = text.replace(/\s/g, '').length;
      
      this.inputCount = counter;
    });

    this.quill.on('text-change', () => {
      const htmlData    = this.getHtmlData();
      const textData    = this.getTextData(htmlData);
      // const textCounter = textData.replace(/\s/g, '').length;

      this.$emit('onEditorChange', {
        delta       : this.quill.getContents(),
        html        : htmlData,
        onlyText    : textData,
        // textCounter : textCounter
      });
    });

    this.quill.root.addEventListener('focus', () => {
      this.toolbarPosition = 'up';
    });

    this.quill.root.addEventListener('blur', () => {
      this.toolbarPosition = 'default';
    });

    this.$nextTick(() => {
      this.isQuillMounted = true;
    });
  },

  beforeDestroy() {
    this.quill = null;
  }
}